{
  "rules": [
    {
      "lhs": "G2.CLASSIFY_INPUT",
      "reason": "G2→G1 seam: classification does not authorize execution",
      "rhs": "G1.HTTP_GET",
      "status": "forbidden"
    },
    {
      "lhs": "G1.HTTP_GET",
      "notes": "HTTP must spend budget",
      "required_gates": [
        "budget",
        "audit"
      ],
      "required_witnesses": [
        "WITNESS.BUDGET_RECEIPT"
      ],
      "rhs": "G4.HTTP_BUDGET",
      "status": "allowed"
    },
    {
      "lhs": "G4.HTTP_BUDGET",
      "notes": "Budget allocation precedes HTTP",
      "required_gates": [
        "budget",
        "audit"
      ],
      "required_witnesses": [
        "WITNESS.BUDGET_RECEIPT"
      ],
      "rhs": "G1.HTTP_GET",
      "status": "allowed"
    },
    {
      "lhs": "G1.APPROVAL_WITNESS",
      "notes": "Inert approval enables HTTP under constraints",
      "required_gates": [
        "phase_separation",
        "audit"
      ],
      "required_witnesses": [
        "WITNESS.HUMAN_APPROVAL",
        "WITNESS.POLICY_EVAL",
        "WITNESS.BUDGET_RECEIPT"
      ],
      "rhs": "G1.HTTP_GET",
      "status": "allowed"
    },
    {
      "lhs": "G2.CLASSIFY_INPUT",
      "notes": "Classification then budget selection",
      "required_gates": [
        "audit"
      ],
      "required_witnesses": [
        "WITNESS.POLICY_EVAL"
      ],
      "rhs": "G4.HTTP_BUDGET",
      "status": "allowed"
    },
    {
      "lhs": "G4.HTTP_BUDGET",
      "notes": "Budget then classification (order-insensitive for demo)",
      "required_gates": [
        "audit"
      ],
      "required_witnesses": [
        "WITNESS.POLICY_EVAL"
      ],
      "rhs": "G2.CLASSIFY_INPUT",
      "status": "allowed"
    },
    {
      "lhs": "G2.CLASSIFY_INPUT",
      "notes": "Classification precedes approval",
      "required_gates": [
        "phase_separation"
      ],
      "required_witnesses": [
        "WITNESS.HUMAN_APPROVAL"
      ],
      "rhs": "G1.APPROVAL_WITNESS",
      "status": "allowed"
    },
    {
      "lhs": "G1.APPROVAL_WITNESS",
      "notes": "Approval then budget",
      "required_gates": [
        "audit"
      ],
      "required_witnesses": [
        "WITNESS.HUMAN_APPROVAL",
        "WITNESS.POLICY_EVAL"
      ],
      "rhs": "G4.HTTP_BUDGET",
      "status": "allowed"
    },
    {
      "lhs": "G4.HTTP_BUDGET",
      "reason": "Approval must precede budget in inert flow",
      "rhs": "G1.APPROVAL_WITNESS",
      "status": "forbidden"
    }
  ],
  "unknown_pair": "forbidden",
  "version": "v1"
}
